<!-- 订单-余额充值、提现记录 -->

<template>
	<div class="order-balance-record-dialog">
		<w-dialog ref="dialogRef" title="订单-余额充值、提现记录" width="30%" top="12vh" :hideFooter="true">
			<!-- 统计面板 -->
			<div class="statistics-panel" v-if="tableData.length > 0">
				<div class="stat-item">
					<div class="label">充值</div>
					<div class="value income">¥ {{ statistics.totalIncome }}</div>
				</div>
				<div class="stat-item">
					<div class="label">提现</div>
					<div class="value expense">¥ {{ statistics.totalExpense }}</div>
				</div>
				<div class="stat-item">
					<div class="label">净额</div>
					<div class="value net">¥ {{ statistics.netAmount }}</div>
				</div>
			</div>
			
			<common-table ref="roleTable" tableHeight="300" :tableData="tableData" :columns="tableColumns" :ispaging="false">
				<!-- 金额列自定义渲染 -->
				<template #money="{ row }">
					<span :class="row.type === 1 ? 'text-green' : 'text-red'">
						{{ row.money }}
					</span>
				</template>
				<!-- 类型列自定义渲染 -->
				<template #type="{ row }">
					<el-tag :type="getTypeTagType(row.type)" size="small">
						{{ getTypeText(row.type) }}
					</el-tag>
				</template>
			</common-table>
		</w-dialog>
	</div>
</template>

<script setup>
	import { ref, watch, computed, nextTick } from "vue";
	import wDialog from "@/components/w-dialog/w-dialog.vue";
	import commonTable from "@/components/common-table/common-table.vue";

	// Props 定义
	const props = defineProps({
		orderBalanceRecordData: {
			type: Array,
			default: () => []
		}
	});

	// 响应式数据
	const dialogRef = ref(null);  // 弹框对象
	const roleTable = ref(null);  // 表格对象
	const tableData = ref([]);  // 表格数据

	// 监听 props 变化，更新表格数据
	watch(() => props.orderBalanceRecordData, (newData) => {
		tableData.value = newData || [];
		// 手动调用表格的 tableLoad 方法刷新数据
		nextTick(() => {
			if (roleTable.value && roleTable.value.tableLoad) {
				roleTable.value.tableLoad();
			}
		});
	}, { immediate: true, deep: true });

	// 计算属性：统计信息
	const statistics = computed(() => {
		if (!tableData.value.length) return { totalIncome: 0, totalExpense: 0, netAmount: 0 };
		
		const totalIncome = tableData.value
			.filter(item => item.type === 1)
			.reduce((sum, item) => sum + Number(item.money), 0);
		
		const totalExpense = Math.abs(tableData.value
			.filter(item => item.type === 3)
			.reduce((sum, item) => sum + Number(item.money), 0));
		
		return {
			totalIncome: totalIncome.toFixed(2),
			totalExpense: totalExpense.toFixed(2),
			netAmount: (totalIncome - totalExpense).toFixed(2)
		};
	});

	/** 表格配置数据 */
	const tableColumns = ref([
		{
			prop: "money",
			label: "金额",
			type: "customRender",
			showTooltip: true,
			minWidth: 120,
		},
		{
			prop: "type",
			label: "类型",
			type: "customRender",
			showTooltip: true,
			minWidth: 100,
		},
		{
			prop: "time",
			label: "时间",
			showTooltip: true,
			minWidth: 160,
		}
	]);



	/**
	 * 获取类型标签样式
	 */
	const getTypeTagType = (type) => {
		const typeMap = {
			'1': 'success',  // 充值
			'3': 'error',  // 提现
		};
		return typeMap[type] || 'info';
	};

	/**
	 * 获取类型文本
	 */
	const getTypeText = (type) => {
		const typeMap = {
			'1': '充值',
			'3': '提现'
		};
		return typeMap[type] || '未知';
	};

	/**
	 * 打开对话框
	 */
	const show = () => {
		dialogRef.value?.show();
	};

	/**
	 * 关闭对话框
	 */
	const close = () => {
		dialogRef.value?.close();
	};

	// 暴露方法给父组件
	defineExpose({
		show,
		close
	});
</script>

<style lang="scss" scoped>
	.order-balance-record-dialog {
		.statistics-panel {
			background: #f8f9fa;
			border-radius: 8px;
			padding: 16px;
			margin-bottom: 16px;
			display: flex;
			justify-content: space-around;
			align-items: center;

			.stat-item {
				text-align: center;
				
				.label {
					font-size: 14px;
					color: #666;
					margin-bottom: 4px;
				}
				
				.value {
					font-size: 18px;
					font-weight: bold;
					
					&.income {
						color: var(--theme-color);
					}
					
					&.expense {
						color: var(--error-color);
					}
					
					&.net {
						color: var(--text-blue-color);
					}
				}
			}
		}

		.text-green {
			color: var(--theme-color);
			font-weight: 500;
		}

		.text-red {
			color: var(--error-color);
			font-weight: 500;
		}
	}
</style>